import { Navigate } from 'react-router-dom';
import { useAuthStore } from '../../store/useAuthStore';
import type { ReactNode } from 'react';

interface Props {
  children: ReactNode;
}

// ── PRIVATE MODE — TO REVERT: restore the `if (accessToken)` redirect below ──
// When private mode is off, logged-in users hitting / go straight to /practice.
// While private mode is on, everyone sees the landing page first; login still
// works normally and /practice is accessible after signing in.
const PRIVATE_MODE = true;

/**
 * Shown only to logged-out visitors.
 * Authenticated users are sent straight to /practice.
 */
export default function LandingRoute({ children }: Props) {
  const accessToken = useAuthStore((s) => s.accessToken);

  // TO REVERT: remove the `&& !PRIVATE_MODE` condition
  if (accessToken && !PRIVATE_MODE) {
    return <Navigate to="/practice" replace />;
  }

  return <>{children}</>;
}
